import { withStyles } from '../../tools/withStyles';
import { Component } from './Layout';
import { styles } from './Layout.styles';

const Layout = withStyles(styles)(Component);

export { Layout };

// Commit trace: 2026-02-19T23:09:26 - refactor: modularize helper functions in index.js
